<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="4">
        <el-input v-model="form.batchCode" size="small" placeholder="批次编码" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="form.batchName" size="small" placeholder="批次名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>
    <div class="table-wrap">
      <div class="btn-text—flex">
        <div class="table-count">外部平台批次数据总数：{{ page.total }}条</div>
      </div>
      <el-table v-loading="tableLoading" :data="tableData" size="small"  @selection-change="handleSelectionChange">
        <el-table-column label="批次编码" min-width="120" prop="batchCode" align="center"></el-table-column>
        <el-table-column label="批次名称" min-width="120" prop="batchName" align="center"></el-table-column>
        <el-table-column label="批次条数" min-width="120" prop="batchNum" align="center"></el-table-column>
        <el-table-column label="关联条数" min-width="120" prop="relateNum" align="center"></el-table-column>
        <el-table-column label="批次总金额" min-width="120" prop="batchMoney" align="center"></el-table-column>
        <el-table-column label="发票照片" prop="invoicePhotoList" align="center">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.invoicePhotoList"></filePreview>
          </template>
        </el-table-column>
        <el-table-column label="快递单号" prop="expressNumber" align="center"></el-table-column>
        <el-table-column label="开票状态" prop="status" align="center">
          <template slot-scope="scope">
            <div v-if="
                scope.row.showStatus == 15
              ">
              审批通过
              <div class="color_danger">(未上传发票)</div>
            </div>
            <div v-else-if="
                scope.row.showStatus == 16
              ">
              审批通过
              <div class="color_success">(已上传发票)</div>
            </div>
            <div v-else-if="
                scope.row.showStatus == 18
              ">
              作废审批中
            </div>
            <template v-else>
              <div v-for="(item,index) in getStatusList" :key="index">
                {{scope.row.showStatus == item.value ?item.label:''}}
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="审批人" prop="approverName" align="center" ></el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="permissions.platform_relate&&scope.row.relateTag==0&&scope.row.relateNum==scope.row.batchNum" type="text" size="small" @click="approve(scope.row.batchId,1)">确认数据关联</el-button>
            <el-button v-if="permissions.platform_relate&&scope.row.relateTag==1" type="text" size="small" @click="approve(scope.row.batchId,0)">撤销数据确认</el-button>
            <el-button v-if="permissions.platform_open_invoice&&(scope.row.status==null||scope.row.status==contractConfig.Status.AssessFail)" type="text" size="small" @click="toInvoice(scope.row.batchId,scope.row.batchMoney)">申请开票</el-button>
            <el-upload v-if="scope.row.status == contractConfig.Status.AssessSucNoUp" :id="'upload-file-3'" :key="'file-3'" class="upload-demo" :action="'https://upload-z2.qiniup.com'" :on-success="uploadSuccess"
              :on-error="uploadError" multiple :before-upload="beforeUpload" @on-change="beforeChange" :show-file-list="false" :accept="'image/gif, image/jpeg, image/jpg, image/png'">
              <el-button type="text" size="small" @click="pidClick(scope.row.batchId)">上传发票照片</el-button>
            </el-upload>
            <el-upload v-if="scope.row.status == contractConfig.Status.AssessSucUp" :id="'upload-file-3'" :key="'file-3'" class="upload-demo" :action="'https://upload-z2.qiniup.com'" :on-success="uploadSuccess"
              :on-error="uploadError" multiple :before-upload="beforeUpload" @on-change="beforeChange" :show-file-list="false" :accept="'image/gif, image/jpeg, image/jpg, image/png'">
              <el-button type="text" size="small" @click="pidClick(scope.row.batchId)">重新上传发票照片</el-button>
            </el-upload>
            <!-- 审批通过-未\已上传发票-->
            <div v-if=" scope.row.status == contractConfig.Status.AssessSucNoUp || scope.row.status == contractConfig.Status.AssessSucUp">
              <el-button type="text" size="small" @click="addOrderClick(scope.row.batchId,scope.row.expressNumber)">{{scope.row.expressNumber?'修改':'录入'}}快递单号</el-button>
            </div>
            <el-button  type="text" size="small" @click="openDetailList(scope.row.batchId)">明细</el-button>
            <el-button v-if="scope.row.status==null||scope.row.status==contractConfig.Status.AssessFail||scope.row.status==contractConfig.Status.Voided" type="text" size="small" @click="deleteBatch(scope.row.batchId)">删除</el-button>
            <el-button v-if=" scope.row.status == contractConfig.Status.AssessSucNoUp || scope.row.status == contractConfig.Status.AssessSucUp" type="text" size="small" @click="cancel(scope.row.batchId)">发票作废</el-button>
         </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div><!-- 分页 -->
   
    </div>
    <!-- 申请开票 -->
    <el-dialog v-if="Invoicedialog" title="申请开票" :visible.sync="Invoicedialog">
      <div class="form-block has-divider bottom">
      <el-form :model="InvoiceForm" ref="InvoiceForm" :rules="rules">
        <el-form-item label="客户名称" prop="customerName" class="block-form-item w-32 select-input-wrap-s">
          <el-input :value="InvoiceForm.customerName" disabled>
            <i slot="append" class="iconfont icon-xialaxuanze_xialaduoxuan" @click="onOpenCustomSelectModal"></i>
          </el-input>
        </el-form-item>


        <el-form-item label="公司电话" prop="companyPhone" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.companyPhone" disabled></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="companyAddress" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.companyAddress" disabled></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="taxpayerId" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.taxpayerId" disabled></el-input>
        </el-form-item>
        <el-form-item label="客户开户行" prop="customerBank" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.customerBank" disabled></el-input>
        </el-form-item>
        <el-form-item label="客户银行账号" prop="customerBankAccount" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.customerBankAccount" disabled></el-input>
        </el-form-item>
        <el-form-item label="发票类型" prop="invoiceType" class="block-form-item w-32">
          <el-select v-model="InvoiceForm.invoiceType" class="w-100">
            <el-option
              v-for="(item, index) in billingConfig.getConfigList('invoiceType')"
              :label="item.name"
              :value="parseInt(item.id)"
              :key="index"
              :disabled="!item.isEnable" 
            >
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{item.name}}</div>
                <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票明细" prop="invoiceDetail" class="block-form-item w-32">
          <el-select v-model="InvoiceForm.invoiceDetail" class="w-100">
            <el-option
              v-for="(item, index) in billingConfig.getConfigList('invoiceDetail')"
              :label="item.name"
              :value="parseInt(item.id)"
              :key="index"
              :disabled="!item.isEnable"
            >
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{item.name}}</div>
                <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票主体" prop="finAccountId" class="block-form-item w-32">
          <el-select v-model="InvoiceForm.finAccountId" class="w-100">
            <el-option 
              v-for="(a, index) in yhgAccountList" 
              :key="index" 
              :label="a.name" 
              :value="a.id"
              :disabled="!a.isEnable">
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{a.name}}</div>
                <div style="margin-left:15px;">{{a.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票备注" prop="remark" class="block-form-item w-99">
          <el-input maxlength="300" show-word-limit type="textarea" v-model="InvoiceForm.remark"></el-input>
        </el-form-item>
        <div class="mar-c">
          <el-button type="primary" size="small" @click="onSubmit" :disabled="submitLoading">提交</el-button>
        </div>
      </el-form>
      </div>
    </el-dialog>

    <el-dialog title="选择甲方签约公司" :visible.sync="customListModal" width="1000px" class="yhg-dialog" @open="openCustomSelectModal">
      <div class="select-con single">
        <span class="label">已选客户：</span>
        <div class="content" v-if="selectCustom">
          <el-tag class="select-tag" closable :type="selectCustom.companyName" effect="dark" @close="onCustomTagClose">
            <span class="select-tag-text">{{ selectCustom.companyName }}</span>
          </el-tag>
        </div>
      </div>
      <div class="filter-con">
        <span class="label">客户搜索：</span>
        <el-input size="small" v-model="customForm.queryString" placeholder="客户名称/编号" @keyup.enter.native="onCustomSearch"></el-input>
        <el-button class="search-btn" size="small" type="primary" @click="onCustomSearch">搜索</el-button>
      </div>
      <div class="table-con">
        <el-table :data="customTable" v-loading="customTableLoading" size="mini" ref="customSelectTable">
          <el-table-column label="选择" width="55" align="center">
            <template slot-scope="scope">
              <span class="hide-label-radio">
                <el-radio v-model="selectCustomId" @change="onChangeCustom" :label="scope.row.id"></el-radio>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="客户编号" prop="code" align="center">
          </el-table-column>
          <el-table-column label="客户名称" prop="companyName" align="center">
          </el-table-column>
          <el-table-column label="客户创建人" prop="createUserName" align="center"></el-table-column>
          <el-table-column label="状态" prop="status" align="center">
            <template slot-scope="scope">
              <p>
                {{ approveConfig.getAppointed("status", scope.row.status, "") }}
              </p>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination background @size-change="customSizeChange" @current-change="customCurrentChange" :current-page.sync="customPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="customPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="customPage.total">
          </el-pagination>
        </div>
      </div>
      <div class="submit-con">
        <el-button type="primary" size="small" @click="onConfirmCustomChoose">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="publicTitle"
      :visible.sync="orderVisible"
      width="30%"
      @close="orderClose">
      <!-- 订单录入 -->
      <div class="orderBox" style="padding:20px 0;">
        <div style="width:100px;">快递单号：</div>
        <el-input style="width:100%;" type="text" placeholder="请输入快递单号" v-model="courierOrder" maxlength="30" show-word-limit></el-input>
      </div>
      <div style="text-align:center;margin-top:10px;">
        <el-button type="primary" @click="saveCourierClick">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="明细信息" :visible.sync="detailVisible" width="80%" v-loading="detailLoading">
		  <template>
		    <el-table
		      :data="detailData"
		      style="width: 100%">
		      <el-table-column label="批次名称" prop="batchName" align="center"></el-table-column>
          <el-table-column label="账单归属" prop="orderOwnerShip" align="center"></el-table-column>
          <el-table-column label="订单号" prop="orderId" align="center"></el-table-column>
          <el-table-column label="任务名称" prop="taskName" align="center"></el-table-column>
          <el-table-column label="账号名称" prop="accountName" align="center"></el-table-column>
          <el-table-column label="发布时间/订单时间" min-width="120" prop="publishTime" align="center">
            <template slot-scope="scope">
              {{ scope.row.publishTime && scope.row.publishTime.split(' ')[0] }}
            </template>
          </el-table-column>
          <el-table-column label="订单金额" prop="orderAccount" align="center">
            <template slot-scope="scope">
              {{ readableNum(scope.row.orderAccount) }}
            </template>
          </el-table-column>
          <el-table-column label="投放记录" prop="putInCode" align="center"></el-table-column>
		    </el-table>
		  </template>
		  <!-- 分页 -->
		  <div class="pagination-wrap">
		    <el-pagination background @size-change="detailSizeChange" @current-change="detailCurrentChange" :current-page.sync="detailpage.pageNum" :page-sizes="[5,10, 20, 30, 40, 50, 100]" :page-size="detailpage.pageSize"
		      layout="sizes, prev, pager, next, jumper" :total="detailpage.total">
		    </el-pagination>
		  </div>
    </el-dialog>

  </div>
</template>

<script>
import xlsx from "xlsx";
import validate from "@/util/validate";
import util from "@/util/util";
import { mediaConfig } from "@/const/config/media";
import { contractConfig } from "@/const/config/invoice";
import { deliveryConfig } from "@/const/config/delivery";
import { billingConfig,billingShow } from "@/const/config/billing";
import { approveConfig } from "@/const/config/approve";
import { listBatch , invioceSubmit ,saveInvoicePhoto,expressNumber,approveRelate,detailList,cancelInvoice,deleteBatch} from "@/api/business/platform";
import {
  getFinAccount , listCustom
} from "@/api/business/contract";
import { mapGetters } from "vuex";
import * as qiniu from "qiniu-js";
import { qiniuToken } from "@/api/index";
export default {
  components: {
  },
  data() {
    return {
      approveConfig, billingConfig ,
      contractConfig: contractConfig,
      ruleForm:{
        path:"",
        name:"",
        desc:"",
      },
      form: {
        batchCode: "",
        batchName: "",
      },
      updateParam:{},

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      tableData: [],
      tableLoading: false,
      InvoiceForm: {
        batchId:"" , //批次ID
        contractId: null, //合同ID
        customerName: "", //名称
        companyPhone: "", //电话
        companyAddress: "", //公司地址
        taxpayerId: "", //纳税人识别号
        customerBank: "", //客户开户行
        customerBankAccount: "", //客户银行账户
        invoiceMoney: "", //开票金额
        invoiceType: "", //发票类型
        invoiceDetail: "", //开票明细
        remark: "", //合同备注
        finAccountId:"",
      },
      Invoicedialog: false, //开票弹窗
      yhgAccountList:[],
      submitLoading: false,
      customListModal:false,
      selectCustomId: null,
      selectCustom: null,
      customForm: {
        queryString: "",
      },
      customPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      customTable: [],
      customTableLoading: false,
      orderVisible:false,//快递单号弹框
      courierOrder:"",//订单
      courierId:"" ,
      publicTitle:"",
      rules: {
        finAccountId: [
          { required: true, message: "请选择开票主体", trigger: "change" },
        ],
      },
      getStatusList:[
        { value: 5,label: '4级审批中'},
        { value: 6,label: '4级审批不通过'},
        { value: 7,label: '3级审批中'},
        { value: 8,label: '3级审批不通过'},
        { value: 9,label: '2级审批中'},
        { value: 10,label: '2级审批不通过'},
        { value: 11,label: '财务审批中'},
        { value: 12,label: '财务审批不通过'},
        { value: 13,label: '出纳审批中'},
        { value: 14,label: '出纳审批不通过'},
        { value: 15,label: '审批通过-未上传发票'},
        { value: 16,label: '审批通过-已上传发票'},
        { value: 17,label: '已作废'},
      ],
      detailVisible: false,
      detailLoading: false,
      detailData:[],//明细记录
      detailpage:{
      pageNum: 1,
      pageSize: 10,
      total: 0,
      batchId:'',
	  },//认领列表分页

    };

  },
  mounted() {
    this.getList();
  },
  methods: {
    // 打开开票
    toInvoice(batchId,batchMoney) {
        this.Invoicedialog = true;
        this.InvoiceForm.batchId = batchId;
        this.InvoiceForm.invoiceMoney = batchMoney ;
        this.InvoiceForm.customerName = "";
        this.InvoiceForm.taxpayerId = null;
        this.InvoiceForm.customerBank = "";
        this.InvoiceForm.customerBankAccount = "";
        this.InvoiceForm.invoiceType = "";
        this.InvoiceForm.invoiceDetail = "";
        this.InvoiceForm.companyAddress = "";
        this.InvoiceForm.companyPhone = "";
        this.getYhgAccount()
    },

    //获取有花果账户列表
    getYhgAccount() {
      getFinAccount({type:0})
        .then((res) => {
          this.yhgAccountList = res.data || [];
        })
        .catch((err) => {
          this.yhgAccountList = [];
        });
    },

    //提交
    onSubmit() {
      if(this.InvoiceForm.finAccountId!=""&&this.InvoiceForm.customerName!=""){
        invioceSubmit(this.InvoiceForm).then((res) => {
        if(res.code === 1){
          this.$message({
            message: '批量开票申请提交成功!',
            type: 'success'
          });
          this.Invoicedialog = false
          this.getList();
        }
        console.log('=======关联======',res)
        })
      }else{
        this.$message.error("表单不完整！请检查客户名称和开票主体是否按要求填写");
      }
      
    },
    //打开资源选择弹窗
    onOpenCustomSelectModal() {
      this.customListModal = true;
    },
    //资源选择变化
    onChangeCustom(val) {
      this.selectCustom = this.customTable.find((v) => v.id == val);
    },
    //资源标签删除
    onCustomTagClose() {
      this.selectCustom = null;
      this.selectCustomId = null;
    },

    //资源选择弹窗打开
    openCustomSelectModal() {
      if (this.form.customerId) {
        this.selectCustom = {
          customId: this.form.customerId,
          companyName: this.form.customerName,
        };
        this.selectCustomId = this.selectCustom.customId;
      } else {
        this.selectCustom = null;
        this.selectCustomId = null;
      }
      this.customForm.queryString = "";
      this.onCustomSearch();
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    customSizeChange(val) {
      this.customPage.pageNum = 1;
      this.customPage.pageSize = val;
      this.getCustomList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    customCurrentChange(val) {
      this.customPage.pageNum = val;
      this.getCustomList();
    },
    //资源搜索
    onCustomSearch() {
      this.customPage.pageNum = 1;
      this.getCustomList();
    },
    //获取资源列表
    getCustomList() {
      let obj = {
        pageSize: this.customPage.pageSize,
        pageNum: this.customPage.pageNum,
      };
      if (this.customForm.queryString && this.customForm.queryString.trim()) {
        obj.nameOrCode = this.customForm.queryString.trim();
      }
      this.customTableLoading = true;
      listCustom(obj)
        .then((res) => {
          this.customTable = res.data || [];
          this.customPage.total = res.total;
          this.customTableLoading = false;
        })
        .catch((err) => {
          this.customTable = [];
          this.customPage.total = 0;
          this.customTableLoading = false;
        });
    },


    onConfirmCustomChoose() {
       if (this.selectCustom) {
         
        this.InvoiceForm.customerName = this.selectCustom.companyName;
        this.InvoiceForm.companyPhone = this.selectCustom.companyPhone;
        this.InvoiceForm.companyAddress = this.selectCustom.companyAddress;
        this.InvoiceForm.taxpayerId = this.selectCustom.taxpayerId;
        this.InvoiceForm.customerBank = this.selectCustom.depositBank;
        this.InvoiceForm.customerBankAccount = this.selectCustom.bankAccount;
        this.InvoiceForm.invoiceType = this.selectCustom.invoiceType;
        this.InvoiceForm.invoiceDetail = this.selectCustom.invoiceDetail;
        console.log("==BBBB==",this.InvoiceForm);
       } else {
         console.log("==AAAA==",this.selectCustom);
        this.InvoiceForm.customerName = "";
        this.InvoiceForm.taxpayerId = null;
        this.InvoiceForm.customerBank = "";
        this.InvoiceForm.customerBankAccount = "";
        this.InvoiceForm.invoiceType = "";
        this.InvoiceForm.invoiceDetail = "";
        this.InvoiceForm.companyAddress = "";
        this.InvoiceForm.companyPhone = "";
       }
       this.customListModal = false;
    },


    //选择
    handleSelectionChange(val){
      this.multiSelectList = val;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        batchName: "",
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      this.tableLoading = true;
      listBatch(queryObj)
        .then((res) => {
          console.log(res.data);
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 展示原因
     * @param reason 原因
     */
    onShowReason(reason) {
      reason = reason || "";
      this.$alert(reason, "投放失败原因", {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },


    beforeChange(file, fileList){
      console.log('========123=======',file, fileList)
    },

    pidClick(id){
      this.pid = id;
      this.imgList=[]
      this.imageIndex=[]
    },

    /**
     * 上传图片
     */
    async beforeUpload(file) {
      this.imageIndex.push(file)
      console.log('======值=====',this.imageIndex.length)
      if (file.size > 500 * 1024 * 1024) {
        this.$message.error("文件大小不能超过500M");
        return false;
      }
      qiniuToken()
        .then((res) => {
          let fileName = Date.now() + file.name;
          var observable = qiniu.upload(file, fileName, res.data);
          console.log(observable);
          observable.subscribe({
            next(res) {},
            error(error) {
              this.$message.error("上传失败");
            },
            complete: (complete) => {
              console.log("complete");
              let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
              this.imgList.push({
                "name": file.name,
                "path": qiniuBaseUrl + complete.key
              })
              if(this.imageIndex.length === this.imgList.length){
                let obj = {
                  batchId: this.pid,
                  invoicePhotoList:this.imgList
                };
                saveInvoicePhoto(obj).then((res) => {
                  if (res.code == 1) {
                    this.$message.success("上传成功！");
                    this.getList();
                  }
                });
              }
            },
          });
        })
        .catch((error) => {});
      return false;
    },
    //上传文件成功
    uploadSuccess(res, file) {
      // file 返回的文件信息，也可以在这里调用七牛上传。
      console.log(file, "success");
    },
    //上传文件失败
    uploadError(res, file) {
      console.log("error", res, file);
    },

    //保存快递单号
    saveCourierClick(){
      if(!this.courierOrder){
        this.$message.error('请输入快递单号');
        return
      }
      expressNumber({id:this.courierId,expressNumber:this.courierOrder}).then(res=>{
        if(res.code === 1){
          this.$message.success("快递单号录入成功!");
          this.getList();
        }
        this.orderVisible = false;
        console.log('====快递单号=====',res)
      })
    },
    //录入/修改快递单号
    addOrderClick(id,expressNumber){
      this.courierOrder = expressNumber;
      this.courierId = id;
      this.publicTitle = '快递单号'
      this.orderVisible = true;
    },

    //关闭快递单号调用
    orderClose(){
      this.orderData = ""
    },

    //确认批次数据全部关联成功
    approve(id,tag){
      approveRelate({id:id,relateTag:tag}).then(res=>{
        if(res.code === 1){
          this.$message.success("确认批次数据全部关联成功!");
          this.getList();
        }
        console.log('====确认批次数据全部关联成功=====',res)
      })
    },


    //打开认领记录
	openDetailList(batchId){
			this.detailVisible = true
			this.getDetail(batchId);
	},
	// 获取认领记录
	getDetail(batchId){
    this.detailpage.batchId = batchId ;
		let obj = {
			batchId:batchId,
			pageNum:this.detailpage.pageNum,
			pageSize:this.detailpage.pageSize,
		}
		detailList(obj)
		  .then((res) => {
				console.log('我是明细记录',res)
				this.detailData = res.data
				this.detailpage.total = res.total;
				console.log('我是认领记录总数',this.detailpage.total)
		  })
		  .catch((err) => {
					
		  });
	},

  /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    detailSizeChange(val) {
      this.detailpage.pageNum = 1;
      this.detailpage.pageSize = val;
      this.getDetail(this.detailpage.batchId);
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    detailCurrentChange(val) {
      this.detailpage.pageNum = val;
      this.getDetail(this.detailpage.batchId);
    },


    //发票作废
    cancel(id){
      this.$prompt(
        `<p>作废后可在批次数据页面，重新申请开票</p><p>作废原因：</p>`,
        "作废发票",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputErrorMessage: "",
          customClass: "msgbox",
          dangerouslyUseHTMLString: "true",
          inputValidator: function (value) {
            if (validate.checkNull(value) || validate.checkNull(value.trim())) {
              return "作废原因不能为空";
            } else if (value.length > 30) {
              return "作废原因长度不能大于30位";
            }
            return true;
          },
        }
      )
        .then(({ value }) => {
          console.log(value);
          let obj = {
            id,
            reason: value.trim(),
          };
          cancelInvoice(obj).then((res) => {
            console.log(res);
            this.$message.success("作废成功");
            this.getList();
          });
        })
        .catch((err) => {});
    },


    

    /**
     * 删除外部平台批次所有数据
     */
    deleteBatch(id) {
      this.$confirm("删除将无法恢复，确认删除该外部平台批次记录吗？", "确认删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "",
        customClass: "msgbox contnt-center",
      })
        .then(() => {
          deleteBatch({ id }).then((res) => {
            console.log(res) ;
            this.$message.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    },

    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-table__header-wrapper  .el-checkbox{
	display:none
}

.form-block {
  position: relative;
  padding-bottom: 20px;

  &.has-divider.top:before {
    content: "";
    position: absolute;
    left: -15px;
    right: -15px;
    top: -15px;
    height: 10px;
    display: block;
    background: #f0f2f5;
    box-shadow: 0 2px 12px 0 rgb(220, 222, 226) inset;
  }
  &.has-divider.bottom:after {
    content: "";
    position: absolute;
    left: -15px;
    right: -15px;
    bottom: 0;
    height: 10px;
    display: block;
    background: #f0f2f5;
    box-shadow: 0 2px 12px 0 rgb(220, 222, 226) inset;
  }

  .title {
    margin: 5px 0;
    font-size: 14px;
  }
  .divider {
    margin: 8px 0 10px;
  }

  &-submit {
    padding-top: 15px;
    text-align: center;
  }

  .block-form-item {
    &.w-25 {
      display: inline-block;
      width: 24%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-32 {
      display: inline-block;
      width: 32%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-99 {
      width: 99%;
      margin-right: 1%;
    }
  }
}

.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
/deep/.select-con {
  .el-tag .el-icon-close {
    top: -1px;
  }
}
</style>

<style lang="scss">
.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 32px;
    height: 32px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      left: -1px;
      font-size: 33px !important;
    }
    cursor: pointer;
  }
}
.avue-view .cost-table {
  width: calc(50% + 100px);
  th {
    background: none;
    font-weight: normal;
    font-size: 14px;
  }
  .cell {
    padding-left: 0;
  }
}
.el-table .operate-column {
  vertical-align: text-top;
}
.orderBox{
  display: flex;
  align-items: center;
}
</style>